import axios from 'axios';

import { BASE_URL } from './config.mjs'; // Ensure correct import

export const adminServiceAPI = axios.default.create({
  baseURL: BASE_URL, // Proxy server running on port 5001
  headers: {
    "Content-Type": "application/json",
  },
});